import type { FC } from 'react';
import React from 'react';
import { Box, Flex, TextV2, TooltipV2 } from '@withjoy/joykit';
import { Help } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import { useTranslation } from '@shared/core';

/**
 * "Note to Guests" label plus the help tooltip that used to sit inside `PageNoteDialog`.
 * Its own file because the copy lives in the `joykit` namespace and a file may only use one.
 */
export const PageNoteLabel: FC = () => {
  const pageNoteTrans = useTranslation('joykit').t('pageNote');

  return (
    <Flex
      gap={1}
      alignItems="center"
    >
      <TextV2 typographyVariant="button2">{pageNoteTrans.noteLabel()}</TextV2>
      <TooltipV2
        overrides={{
          Content: { props: { paddingY: 4, paddingLeft: pxToRem(14), paddingRight: 4, borderRadius: pxToRem(12), color: 'white' } },
        }}
        content={
          <Flex
            flexDirection="column"
            maxWidth={pxToRem(256)}
          >
            <Box typographyVariant="label3">{pageNoteTrans.tooltip.title()}</Box>
            <Box
              typographyVariant="label2"
              color="mono4"
            >
              {pageNoteTrans.tooltip.content()}
            </Box>
          </Flex>
        }
        onMouseEnterDelay={500}
      >
        <Help
          size={16}
          color="mono10"
        />
      </TooltipV2>
    </Flex>
  );
};

PageNoteLabel.displayName = 'PageNoteLabel';
